import { Shape } from "./shape";


export class teamEnabling extends Shape{
    override width: number = 25;
    override height: number = 50;
    override rx: number= 2.5;
    override ry: number = 2.5;
    override color: string = "#dfbdce";
    override strokeColor: string = "#d2a1ba";
    override strokeDashArray: [number, number] = [0,0];
    
    

    constructor() {
        super();
    }

}